import styled from "styled-components";

export const RaceDetail = styled.div`
  display: flex;

  &:not(:first-child):not(:last-child) {
    padding: ${({ theme }) => `0 ${theme.space["space-2"]}`};
    border-left: ${({ theme }) =>
      `1px solid ${theme.colorTokens.content.subtle3}`};
  }

  &:first-child {
    margin-right: ${({ theme }) => theme.space["space-3"]};
  }
`;

export const ChangeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
